import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Select, Radio, Col, Input } from 'antd';
import { injectIntl, FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react';
import { Row } from '../../styled';
import ENUMS from '../../../../../constants/enums';
import { config } from '../../config';
import IconSvg from '../../../../common/IconSvg';

const { FREE_SHIPPING, COST } = ENUMS.SHIPPING_COSTS;
const { shippingMethodColSpan: span } = config;
const { Option } = Select;
const FREE_SHIPPING_PRICE = 0;
const isFreeShipping = cost => cost === FREE_SHIPPING_PRICE;

const RadioControls = styled(Radio.Group)`
  & * {
    font-weight: 400;
  }
`;

const Container = styled.div`
  margin-bottom: 1em;
  & > * {
    margin: 0.5em 0;
  }
`;

class ShippingMethod extends Component {
  constructor(props) {
    super(props);
    this.inputRef = React.createRef();
    this.state = {
      disabledBtn: isFreeShipping(props.cost),
      currentValue: isFreeShipping(props.cost) ? FREE_SHIPPING : COST,
    };
    this.handleFreeShipping = this.handleFreeShipping.bind(this);
    this.handlePaidShipping = this.handlePaidShipping.bind(this);
    this.handleOnBlur = this.handleOnBlur.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
  }

  handleFreeShipping() {
    const { setPrice } = this.props;
    this.setState({ disabledBtn: true, currentValue: FREE_SHIPPING });
    setPrice(FREE_SHIPPING_PRICE);
  }

  handlePaidShipping() {
    this.setState({ disabledBtn: false, currentValue: COST }, () => this.inputRef.current.focus());
  }

  handleOnBlur() {
    const { cost } = this.props;
    if (isFreeShipping(cost) || isNaN(cost)) {
      this.handleFreeShipping();
    }
  }

  handleSelect(key) {
    const { updateMethodType, onSelect } = this.props;
    updateMethodType(key);
    onSelect();
  }

  render() {
    const { methodName, cost, allMethods, setPrice, title, deleteMethod } = this.props;
    const { disabledBtn, currentValue } = this.state;
    return (
      <Container>
        <Row>
          <Col span={span}>
            <FormattedMessage id={title} />
          </Col>
          <Col span={span}>
            <Select
              value={methodName}
              onChange={(e, { key }) => this.handleSelect(key)}
              style={{ minWidth: '97px' }}
            >
              {allMethods.map(({ methodName: name, methodKey }) => (
                <Option key={methodKey} value={name}>
                  {name}
                </Option>
              ))}
            </Select>
            <IconSvg type="x" onClick={deleteMethod} marginLeft="8px" size={10} />
          </Col>
        </Row>
        <Row>
          <Col span={span}>{methodName}</Col>
          <RadioControls value={currentValue}>
            <Radio value={COST} onClick={this.handlePaidShipping}>
              <FormattedMessage id="listing.cost" />
              &nbsp; $ &nbsp;
              <Input
                type="number"
                style={{ width: '5em' }}
                value={cost}
                disabled={disabledBtn}
                onChange={({ target: { value } }) => setPrice(value)}
                onBlur={this.handleOnBlur}
                ref={this.inputRef}
              />
            </Radio>
            <Radio value={FREE_SHIPPING} onClick={this.handleFreeShipping}>
              <FormattedMessage id="listing.freeShipping" />
            </Radio>
          </RadioControls>
        </Row>
      </Container>
    );
  }
}

ShippingMethod.defaultProps = {
  onSelect: () => {},
};

ShippingMethod.propTypes = {
  title: PropTypes.string,
  methodName: PropTypes.string,
  cost: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  allMethods: PropTypes.arrayOf(PropTypes.shape),
  setPrice: PropTypes.func,
  updateMethodType: PropTypes.func,
  deleteMethod: PropTypes.func,
  onSelect: PropTypes.func,
};

export default injectIntl(observer(ShippingMethod));
